import { yup } from '@guiker/yup-util'

export const amenitySchema = yup.boolean().nullable().default(false)
